import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
  usuarioPerfilFinanceiro
} from '../../usuario/usuario-perfil';

/** Acessos permitidos a análise de mercado de cliente  */
export const CLIENTES_ANALISES_MERCADOS_ACESSOS: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
  usuarioPerfilFinanceiro
];

@Injectable()
export class CanActivateClienteAnaliseMercado implements CanActivateChild {
  constructor(private authGuard: AuthGuard) {}

  canActivateChild(): boolean {
    return this.authGuard.canActivateAcesso(CLIENTES_ANALISES_MERCADOS_ACESSOS);
  }
}
